export default "__VITE_PUBLIC_ASSET__814fba8d__"